import ProductPage from "ProductPage/productPage";
import ProductOptions from "ProductPage/model/productOptions";

try {
	let options = new ProductOptions({
		id: window.productOptions.id
	});

	window.page = new ProductPage(options);
} catch (ex) {
	console.error(ex);
}